// player-application/src/containers/CreateSetlist/createSetlistFromQuery.js

import { fetchLibrarySongsAsync } from "../../features/library/librarySlice";
import { createSetlistFromData } from "../../features/setlists/setlistsSlice";
import { removeSetListFromSetlists, uncacheSetlistAssetsAsync} from '../../features/setlists/setlistsSlice';

// pgw 07-feb-2026
let doprint = false;
// let doprint = true;



function fromBase64Url(b64url) {
  if (!b64url) return null;
  // reverse base64url -> base64
  let s = String(b64url).replace(/-/g, "+").replace(/_/g, "/");
  // pad
  while (s.length % 4) s += "=";
  return atob(s);
}

function safeParseJson(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    console.warn("[createSetlistFromQuery] failed to parse JSON", e);
    return null;
  }
}

export const setlistTitleExists = (title, existingSetlists) => {
  if (!title || !existingSetlists) return false;

  const normalisedTitle = title.trim().toLowerCase();

  // existingSetlists can be an array OR an object map
  const list = Array.isArray(existingSetlists)
    ? existingSetlists
    : Object.values(existingSetlists);

  return list.some(
    setlist =>
      typeof setlist?.title === "string" &&
      setlist.title.trim().toLowerCase() === normalisedTitle
  );
};


export const findSetlistIdByTitle = (title, existingSetlists) => {
  if (!title || !existingSetlists) return null;

  const normalisedTitle = title.trim().toLowerCase();

  // existingSetlists can be an array OR an object map
  const list = Array.isArray(existingSetlists)
    ? existingSetlists
    : Object.values(existingSetlists);

  const match = list.find(
    setlist =>
      typeof setlist?.title === "string" &&
      setlist.title.trim().toLowerCase() === normalisedTitle
  );

  return match?.id || null;
};

export const findSetlistByTitle = (title, existingSetlists) => {
  if (!title || !existingSetlists) return null;

  const normalisedTitle = title.trim().toLowerCase();

  // existingSetlists can be an array OR an object map
  const list = Array.isArray(existingSetlists)
    ? existingSetlists
    : Object.values(existingSetlists);

  return (
    list.find(
      setlist =>
        typeof setlist?.title === "string" &&
        setlist.title.trim().toLowerCase() === normalisedTitle
    ) || null
  );
};


export const findSetlistById = (setlistId, existingSetlists) => {
  if (!setlistId || !existingSetlists) return null;

  // existingSetlists can be an array OR an object map
  const list = Array.isArray(existingSetlists)
    ? existingSetlists
    : Object.values(existingSetlists);

  return (
    list.find(
      setlist =>
        setlist?.id === setlistId
    ) || null
  );
};


/**
 * Returns setlists without the setlist that has the given id.
 *
 * @param {Array|Object} setlists - array of setlists OR map keyed by id
 * @param {string} setlistId - id to remove
 * @returns {Array|Object} new setlists without that id
 */
export const removeSetlistById = (setlists, setlistId) => {
  if (!setlists || !setlistId) return setlists;

  // Array form
  if (Array.isArray(setlists)) {
    return setlists.filter(s => s?.id !== setlistId);
  }

  // Object / map form
  const { [setlistId]: _removed, ...rest } = setlists;
  return rest;
};



/**
 * Runs the same logic that CreateSetlistContainer used to run in its useEffect.
 *
 * @param {object} args
 * @param {function} args.dispatch - redux dispatch
 * @param {object|null} args.currentUser - current user (must exist)
 * @param {Array|Object} args.setlists - existing setlists array OR map
 * @param {object} args.query - object with get(key) -> string|null (URLSearchParams-compatible)
 */
export async function createSetlistFromQuery({ dispatch, currentUser, setlists, query }) {
  if (doprint) console.log("[createSetlistFromQuery] start");


  let currentSetlists = setlists;

  // same as CreateSetlistContainer
  const fetchedLibrarySongsRequest = await dispatch(
    fetchLibrarySongsAsync({ startIndex: 0, limit: 600 })
  );

  if (!currentUser) {
    if (doprint) console.log("[createSetlistFromQuery] no currentUser -> returning");
    return { created: false, reason: "no_user" };
  }

  const setlistId = query.get("setlistId");
  const title = query.get("title");
  const subtitle = query.get("subtitle");
  const imageUrlB64 = query.get("imageUrl");
  const itemsCsv = query.get("items");


/*
  if (!setlistId || !title || !itemsCsv) {
    console.warn("[createSetlistFromQuery] missing params", { setlistId, title, itemsCsv });
	alert('setlistId or title or itemsCsv missing');
    // return { created: false, reason: "missing_params" };
  }
*/

  if (!setlistId || !title) {
    console.warn("[createSetlistFromQuery] missing params", { setlistId, title });
	alert('There is a problem with the setlist link: the setlist id or title are missing !');
    return { created: false, reason: "missing_params" };
  }

  if (doprint) console.log("[createSetlistFromQuery] currentSetlists =", currentSetlists);
  if (doprint) console.log("[createSetlistFromQuery] title =", title);
  if (doprint) console.log("[createSetlistFromQuery] subtitle =", subtitle);
  if (doprint) console.log("[createSetlistFromQuery] setlistId =", setlistId);

  const hasSub = !!currentUser?.subscribed;
  if (doprint) console.log("[createSetlistFromQuery] hasSub =", hasSub);

  if (!hasSub) {
    alert("Sorry - you cannot do that unless you are logged in.");
    return { created: false, reason: "no_sub" };
  }


  let existingSetlist = false;

  // --- Title duplicate check ---
  if (setlistTitleExists(title, currentSetlists)) {
    console.warn("[createSetlistFromQuery] Setlist with this title already exists");

    const res = confirm("You already have a setlist with the same name. Continue and replace it?");
    console.log("res =", res);

    if (!res) {
      console.log("You pressed Cancel - returning...");
      return { created: false, reason: "dup_title_cancel" };
    }

    const existingSetlist = findSetlistByTitle(title, currentSetlists);
    if (doprint) console.log("[createSetlistFromQuery] existingSetlist 1 = ", existingSetlist);

    if (existingSetlist) {

    if (doprint) console.log("[createSetlistFromQuery] existingSetlist 2 = ", existingSetlist);

//       await dispatch(uncacheSetlistAssetsAsync(existingSetlist));
    if (doprint) console.log("[createSetlistFromQuery] existingSetlist 3 = ", existingSetlist);
      await dispatch(removeSetListFromSetlists(existingSetlist.id));
    if (doprint) console.log("[createSetlistFromQuery] existingSetlist 4 = ", existingSetlist);

	  currentSetlists = removeSetlistById(currentSetlists, existingSetlist.id);

    if (doprint) console.log("[createSetlistFromQuery] existingSetlist 5 = ", existingSetlist);
    if (doprint) console.log("[createSetlistFromQuery] currentSetlists= ", currentSetlists);


    } else {
      // Should not happen if setlistTitleExists is true, but guard anyway
      console.warn("[createSetlistFromQuery] Title existed but findSetlistByTitle returned null");
    }
  }

  if (doprint) console.log("[createSetlistFromQuery] currentSetlists =", currentSetlists);

/*

  // --- ID duplicate check ---
  const existingById = findSetlistById(setlistId, currentSetlists);
  if (existingById) {
    console.warn("Setlist with this id already exists");

    const res = confirm("You already have a setlist with the same id. Continue and replace it?");
    console.log("res =", res);

    if (!res) {
      console.log("You pressed Cancel - returning...");
      return { created: false, reason: "dup_id_cancel", setlistId };
    }

    if (doprint) console.log("[createSetlistFromQuery] existingSetlist (id) = ", existingById);
    // await dispatch(uncacheSetlistAssetsAsync(existingById));
    await dispatch(removeSetListFromSetlists(existingById.id));

	currentSetlists = removeSetlistById(currentSetlists, existingSetlist.id);

  }
*/

  if (doprint) console.log("[createSetlistFromQuery] currentSetlists 1 =", currentSetlists);


  const songIdsInOrder = itemsCsv.split(",").filter(Boolean);

  // decode optional settings=[ ... ]
  const settingsB64 = query.get("settings");
  const decodedSettingsJson = settingsB64 ? fromBase64Url(settingsB64) : null;
  const settingsByIx = decodedSettingsJson ? safeParseJson(decodedSettingsJson) : null;

  if (doprint) console.log("[createSetlistFromQuery] decoded settings", {
	hasSettingsParam: !!settingsB64,
	parsed: Array.isArray(settingsByIx),
	len: Array.isArray(settingsByIx) ? settingsByIx.length : null,
  });

  // build items IN THE SAME ORDER as songIdsInOrder
  const librarySongs = fetchedLibrarySongsRequest.payload || [];
  const bySongId = new Map(librarySongs.map(s => [s.songId, s]));

  const itemsWithSettings = songIdsInOrder
	.map((songId, ix) => {
	  const song = bySongId.get(songId);
	  if (!song) return null;

	  const itemSettings =
		Array.isArray(settingsByIx) && settingsByIx[ix]
		  ? settingsByIx[ix]
		  : null;

	  return {
		...song,
		ix,                 // keep stable index for setlist usage
		itemSettings,       // ✅ THIS is the key your setlist open logic reads
	  };
	})
	.filter(Boolean);

  if (doprint) console.log("[createSetlistFromQuery] itemsWithSettings preview", {
	count: itemsWithSettings.length,
	first: itemsWithSettings[0]
	  ? {
		  songId: itemsWithSettings[0].songId,
		  hasItemSettings: !!itemsWithSettings[0].itemSettings,
		  speed: itemsWithSettings[0].itemSettings?.speed,
		  pitch: itemsWithSettings[0].itemSettings?.pitch,
		  stems0: itemsWithSettings[0].itemSettings?.stems?.[0],
		}
	  : null,
  });

  await dispatch(
	createSetlistFromData({
	  setlistId,
	  title,
	  subtitle,
	  imageUrl: imageUrlB64 ? atob(imageUrlB64) : null,
	  items: itemsWithSettings,   // ✅ not a filter() anymore
	  readOnly: true,
	})
  );



  if (doprint) console.log("[createSetlistFromQuery] currentSetlists 3 =", currentSetlists);

  if (doprint) console.log("[createSetlistFromQuery] created setlist", setlistId);
  return { created: true, setlistId };
}


